import { AreaCategory, WorkoutSettings } from 'fitbeat.gym-core';
import { CardioOrResistance, Gym, GymTypes } from 'fitbeat.models';
import moment from 'moment-timezone';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import CalendarIcon from '../../assets/images/calendar.svg';
import DurationIcon from '../../assets/images/duration.svg';
import Theme from '../../theme';
import { getSlotTime } from '../../utils';
import { defaultScale, scaleImageAspectRatio } from '../../utils/scaling';
import { BackgroundImageHeader } from './BackgroundImageHeader';
import {
  getAreaCategorySummaryImage,
  getAreaCategorySummaryTitle,
  getAreaIcon,
} from '../../utils/areaCategoryMapping';

interface IProps {
  areaCategory: AreaCategory | 'home';
  gym: Gym;
  pendingSlot: any;
  isSoloWorkout: boolean;
  workoutSettings: WorkoutSettings;
  closeModal?(): void;
  t(key: string, options?: any): string;
}

export function BookingSummary({
  t,
  areaCategory,
  pendingSlot,
  closeModal,
  workoutSettings,
  gym,
}: IProps) {
  const iconWidth = defaultScale(15);
  const iconHeight = defaultScale(15);

  const formattedBookingTime = () => {
    const time = pendingSlot.startTimeOfFirstExercise || pendingSlot.startTime;
    const format = 'D MMM, HH:mm';
    if (gym.type === GymTypes.Indoor) {
      return moment(time).tz(gym.timezone).format(format);
    }
    return moment(time).format(format);
  };

  const isHomeBooking = gym.type === GymTypes.Home;

  return (
    <View>
      <BackgroundImageHeader
        onClose={closeModal}
        title={getAreaCategorySummaryTitle(areaCategory, t)}
        titleStyle={{
          ...Theme.textStyle.heading,
          marginLeft: defaultScale(6),
          marginBottom: defaultScale(6),
          color: Theme.WHITE,
        }}
        containerStyle={{ width: '100%', aspectRatio: scaleImageAspectRatio(1.7) }}
        imageSource={getAreaCategorySummaryImage(areaCategory)}
        gradientHeight='50%'
        icon={getAreaIcon(areaCategory, Theme.WHITE)}
        gradientOpacity={1}
        useGradient
        closeIconContainerStyle={{
          marginTop: defaultScale(15),
          marginHorizontal: defaultScale(15),
        }}
        actions={(
          <View
            style={{
              flexDirection: 'row',
              marginLeft: defaultScale(6),
              alignItems: 'center',
            }}
          >
            <View style={styles.iconContainer}>
              <DurationIcon
                width={iconWidth}
                height={iconHeight}
                color={Theme.WHITE}
              />
              <Text style={styles.iconText}>
                {getSlotTime(pendingSlot, isHomeBooking)}
              </Text>
            </View>
            <View style={styles.iconContainer}>
              <CalendarIcon
                width={iconWidth}
                height={iconHeight}
              />
              <Text style={styles.iconText}>
                {pendingSlot.isInstant
                  ? t('startingNow')
                  : formattedBookingTime()}
              </Text>
            </View>
          </View>
        )}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  iconContainer: {
    flexDirection: 'row',
    marginRight: defaultScale(25),
    alignItems: 'center',
  },
  iconText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.WHITE,
    marginLeft: defaultScale(6),
  },
});
